import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';

@Component({
  selector: 'app-mdllistvendor',
  templateUrl: './mdllistvendor.component.html',
  styleUrls: ['./mdllistvendor.component.css']
})
export class MdllistvendorComponent implements OnInit {

  data: any;

  constructor(private engineeringServices : EngineeringService, private router : Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getMdlList();
  }

  getMdlList() {
    this.engineeringServices.GetMdlListVendor().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  submitDrawing = function (id) {
    //alert(id);
    this.router.navigate(['/submitdrawing/' + id + '']);
  }
  mdllistvendorsearch(keyword){
    this.engineeringServices.MDLListVendorSearch(keyword).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
      }
    )
  }

}
